import { useDispatch } from 'react-redux';

import { TranslationCoverage, translationModel } from 'entities/translation';

import { CoverageLanguage, EEntityType } from 'shared/api';

type CoverageSortKey = 'language' | keyof Omit<CoverageLanguage, 'language'>;

type Props = {
  selectedType: EEntityType | null;
  selectedLanguage: string | null;
  sortBy: string;
  sortOrder: 'asc' | 'desc';
  onSortChange: (key: CoverageSortKey) => void;
  onCellClick: (type: EEntityType, language: string) => void;
  onLanguageClick: (language: string) => void;
};

export const CoverageSection = ({
  selectedType,
  selectedLanguage,
  sortBy,
  sortOrder,
  onSortChange,
  onCellClick,
  onLanguageClick,
}: Props) => {
  const dispatch = useDispatch();

  const { isLoading } = translationModel.getCoverageMatrixAsync()(dispatch);
  const { coverage, languages } = translationModel.useTranslationState();

  return (
    <TranslationCoverage
      coverage={coverage}
      languages={languages}
      isLoading={isLoading}
      selectedType={selectedType}
      selectedLanguage={selectedLanguage}
      sortBy={sortBy}
      sortOrder={sortOrder}
      onSortChange={onSortChange}
      onCellClick={onCellClick}
      onLanguageClick={onLanguageClick}
    />
  );
};
